
const buttons = document.querySelectorAll('button[data-next-section]');

buttons.forEach(button => button.addEventListener('click', nextSection));

function nextSection(e) {
  const currentSection = e.currentTarget.closest('section, .section');
  const nextSection = currentSection.nextElementSibling;
  nextSection.scrollIntoView({behavior: 'smooth', block:'start'});
}
